import "Styles/templates/page.collab-landing.scss";

import collectionListingApp from '../vue/collection-listing/index';

collectionListingApp();